<div>

    <h2>Dashboard</h2>

    <div class="grid gap-4 md:grid-cols-2">

        <div>
            <app-logs></app-logs>
        </div>

        <div>
            <app-status></app-status>
        </div>

    </div>

    </div>
